import { Injectable } from '@angular/core';
import { HttpDataService } from '../http/http-data.service';

import { ILocationExtended } from '../../../type_definitions/datatypes';

@Injectable()
export class BPProfilesLocationsDataService {
  constructor(
    private httpDataService:HttpDataService
  ) {
    /**/
  }

  public getLocations(profileId:number, countryId?:number):Promise<ILocationExtended[]> {
    return this.httpDataService.doGET(
      `rest/bpprofiles/profiles/${profileId}/locations`,
      { countryId },
      undefined,
      'Error loading locations'
    );
  }

  public deleteLocation(profileId:number, location:ILocationExtended):Promise<void> {
    return this.httpDataService.doDELETE(
      `rest/bpprofiles/profiles/${profileId}/locations/${location.id}`,
      undefined,
      'Deleting location…',
      'Error deleting location'
    );
  }

  public setLocationHeadquarter(profileId:number, location:ILocationExtended, hq:string):Promise<void> {
    return this.httpDataService.doPUT(
      `rest/bpprofiles/profiles/${profileId}/${hq}-headquarters/${location.id}`,
      undefined,
      {},
      `Setting ${hq} HQ…`,
      `Error setting headquarter`
    );
  }

  public addNewLocation(profileId:number, location:ILocationExtended):Promise<ILocationExtended> {
    return this.httpDataService.doPOST(
      `rest/bpprofiles/profiles/${profileId}/locations`,
      undefined,
      location,
      undefined,
      'Error adding location'
    );
  }

  public updateLocation(profileId:number, location:ILocationExtended):Promise<ILocationExtended> {
    return this.httpDataService.doPUT(
      `rest/bpprofiles/profiles/${profileId}/locations/${location.id}`,
      undefined,
      location,
      undefined,
      'Error updating location'
    );
  }
}